var _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclusiveResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2655 11.1382L18.1434 10.2786C18.7031 10.1587 18.903 9.45906 18.5032 9.03928L17.6437 8.17973L21.2418 4.58163C21.6016 4.22182 21.6016 3.64212 21.2418 3.28231C20.882 2.9225 20.3023 2.9225 19.9425 3.28231L16.3444 6.88042L15.4848 6.02087C15.085 5.62108 14.3854 5.82097 14.2455 6.38068L13.3859 10.2586C13.286 10.7984 13.7457 11.2581 14.2655 11.1382Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6637 16.8352L18.5232 15.9756C18.923 15.5759 18.7231 14.8762 18.1634 14.7363L14.2855 13.8767C13.7657 13.7568 13.306 14.2366 13.4059 14.7563L14.2655 18.6342C14.3854 19.194 15.085 19.3938 15.5048 18.9941L16.3644 18.1345L19.9625 21.7326C20.1424 21.9125 20.3822 22.0125 20.6221 22.0125C20.862 22.0125 21.1019 21.9125 21.2818 21.7326C21.6416 21.3728 21.6416 20.7931 21.2818 20.4333L17.6637 16.8352Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.11829,
    y: 2.51245,
    width: 2,
    height: 19,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.11829,
    y: 2.51245,
    width: 2,
    height: 19,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusiveResource);
export default __webpack_public_path__ + "static/media/exclusive-resource.54df7032d1ad6bb7ee7d423e7bcc6acd.svg";
export { ForwardRef as ReactComponent };